(function (){
    'use strict';

    angular
        .module('services')
        .service('ProfileTypeService', ProfileTypeService);

    ProfileTypeService.$inject = ['$http', 'API_BASE'];

    function ProfileTypeService ($http, API_BASE) {
        var service = this;

        service.getProfilesType        = getProfilesType;

        function getProfilesType (request) {
            return $http.get(API_BASE + '/profiles/list',{params:request});
        }



    }
})();